import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import AdminLogin from "./components/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminLeads from "./components/admin/AdminLeads";
import AdminReferralSources from "./components/admin/AdminReferralSources";
import AdminTasks from "./components/admin/AdminTasks";
import AdminUsers from "./components/admin/AdminUsers";
import AdminReferrals from "./components/admin/AdminReferrals";
import AdminServices from "./components/admin/AdminServices";
import AdminContacts from "./components/admin/AdminContacts";
import AdminReports from "./components/admin/AdminReports";

const App = () => {
  return (
    <Routes>
      {/* Admin Routes */}
      <Route path="/admin/auth/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="referral-sources" element={<AdminReferralSources />} />
        <Route path="tasks" element={<AdminTasks />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="referrals" element={<AdminReferrals />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="contacts" element={<AdminContacts />} />
        <Route path="reports" element={<AdminReports />} />
      </Route>

      {/* Redirect root to admin login */}
      <Route path="/" element={<Navigate to="/admin/auth/login" replace />} />
    </Routes>
  );
};

export default App;
